<template>
  <div class="d-f fd-c ai-c w-100 m-b-children">
    <UploadImgLabel :defaultSrc="labelSettings.logo" @changed="setLogo" />

    <div class="input-container w-100">
      <label class="label" for="labelName" :class="{ error: usernameError }"
        >Label Name</label
      >
      <input
        id="labelName"
        v-model="labelName"
        name="labelName"
        placeholder="Label Name"
        type="text"
        :class="{ error: usernameError }"
        @input="usernameError = ''"
        @blur="restoreLabelNameIfEmpty"
      />
    </div>
    <p v-if="usernameError" class="as-s font-small error red">
      {{ usernameError }}
    </p>

    <LocationInput
      :default-location="{ address: location }"
      @changed="location = $event.address"
    />

    <GenreSelect
      :value="labelSettings.genres"
      :standalone="false"
      @input="genreSelected = $event"
    />

    <div class="input-container w-100 desc-field">
      <label class="label" for="shortDescription">Short description</label>
      <input
        id="shortDescription"
        v-model="shortDescription"
        maxlength="80"
        name="shortDescription"
        placeholder="Short description (Max 80 characters)"
        type="text"
        class="desc-input"
      />
      <span class="char-count font-small mute">{{ (shortDescription || '').length }}/80</span>
    </div>
    <div class="input-container w-100 desc-field desc-textarea-wrap">
      <label class="label" for="description">Long description</label>
      <textarea
        id="description"
        v-model="description"
        maxlength="600"
        name="description"
        placeholder="Long description"
        rows="3"
        class="desc-textarea"
      />
      <span class="char-count font-small mute">{{ (description || '').length }}/600</span>
    </div>

    <div class="label-divider p-rel w-100">
      <span class="w-100 b-bottom p-a pos-center"></span>
      <h4 class="font-small mute tt-up p-a pos-center m-0 t-100 bc-brand p">
        External Links
      </h4>
    </div>

    <div v-for="link in externalLinks" :key="link.id" class="d-f w-100 g">
      <div class="input-container flex-1">
        <label :for="'linkUrl' + link.id" class="label">www.MyWebsite.com</label>
        <input
          :id="'linkUrl' + link.id"
          v-model="link.url"
          :name="'linkUrl' + link.id"s
          placeholder="www.mywebsite.com"
          type="text"
          @keydown="linkDataChanged"
        />
      </div>
      <div class="input-container flex-1">
        <label :for="'linkTitle' + link.id" class="label">My Website</label>
        <input
          :id="'linkTitle' + link.id"
          v-model="link.title"
          :name="'linkTitle' + link.id"
          placeholder="My Website"
          type="text"
          @keydown="linkDataChanged"
        />
      </div>
    </div>

    <div class="label-divider p-rel w-100">
      <span class="w-100 b-bottom p-a pos-center"></span>
      <h4 class="font-small mute tt-up p-a pos-center m-0 t-100 bc-brand p">
        Account
      </h4>
    </div>
    <div
      class="toggle-wrapper"
      @click.prevent="publicProfile = !publicProfile"
    >
      <div class="flex-1">Public profile</div>
      <ToggleSwitch :value="publicProfile" />
    </div>

    <div
      ref="optOut"
      id="opt-out"
      class="toggle-wrapper"
      :class="{ 'b-brand': $route.hash.includes('opt-out') }"
      @click.prevent="mailSubscriptionStatus = !mailSubscriptionStatus"
    >
      <div class="flex-1">Opt-out of Profile Summary Emails</div>
      <ToggleSwitch :value="!mailSubscriptionStatus" />
    </div>

    <div class="label-divider p-rel w-100">
      <span class="w-100 b-bottom p-a pos-center"></span>
    </div>

    <div class="d-f" v-if="!showDeleteOption && !showChangePassword">
      <div class="text-link" @click="showChangePassword = true">
        Change Password
      </div>
      <span class="m-l m-r grey o-5">|</span>
      <div class="text-link" @click="logout()">Log Out</div>
      <span class="m-l m-r grey o-5">|</span>
      <div class="text-link" @click="showDeleteOption = true">
        Delete Account
      </div>
    </div>
    <!-- Change Password -->
    <div class="d-f fd-c w-100 jc-c">
      <div class="w-100 bs-bb d-f ai-c jc-c" v-if="showChangePassword">
        <div class="w-100 d-f fd-c g">
          <div class="input-container w-100">
            <label class="label" for="confirm-pass">Current Password</label>
            <input
              type="password"
              id="confirm-pass"
              name="confirm-pass"
              v-model="currentPassword"
              placeholder="Current Password"
            />
          </div>
          <div class="input-container w-100">
            <label
              class="label"
              for="change-pass"
              :class="{ error: passwordMismatch }"
              >New Password</label
            >
            <input
              type="password"
              id="change-pass"
              name="change-pass"
              v-model="newPassword"
              placeholder="New Password"
              :class="{ error: passwordMismatch }"
            />
          </div>
          <div class="input-container w-100">
            <label
              class="label"
              for="confirm-new-pass"
              :class="{ error: passwordMismatch }"
              >Confirm New Password</label
            >
            <input
              type="password"
              id="confirm-new-pass"
              name="confirm-new-pass"
              v-model="confirmNewPassword"
              placeholder="Confirm New Password"
              :class="{ error: passwordMismatch }"
            />
          </div>
          <p v-if="passwordMismatch" class="as-s p-l error">
            Passwords do not match
          </p>
          <div class="d-f jc-c ai-c g p">
            <button @click.prevent="savePassword" :disabled="passwordMismatch">
              Save Password
            </button>
            <button class="secondary" @click="resetPasswordForm">Cancel</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Delete account -->
    <div class="delete-account w-100 bs-bb d-f ai-c jc-c">
      <div class="w-100 d-f fd-c g" v-if="showDeleteOption">
        <p class="">Are you sure you want to delete this account?</p>
        <div class="d-f jc-c ai-c g p">
          <button class="" @click="deleteAccount">Confirm deletion</button>
          <button class="secondary" @click="showDeleteOption = false">
            Cancel
          </button>
        </div>
      </div>
    </div>

    <div class="save-buttons d-f jc-c ai-c p-f b-0 bc-brand w-100 m-b-0 p">
      <div class="d-f g">
        <button type="button" class="secondary d-f ai-c" @click="goBack">
          Cancel
        </button>
        <button
          :disabled="!dataChanged || saving"
          class="primary d-f ai-c g"
          type="button"
          @click="handleSaveAndClose"
        >
          <span>{{ saving ? "Saving changes" : "Save Changes" }}</span>
          <!-- <IconBase color="#fff" w="15" h="15" view-box="0 0 15 15" icon-name="back">
            <IconCheck />
          </IconBase> -->
        </button>
        <!-- <button
          :disabled="saving"
          class="d-f ai-c g"
          type="submit"
          @click.prevent="handleNext"
        >
          Next
          <IconBase color="#000" w="15" h="15" viewBox="0 0 15 15" icon-name="continue">
            <IconArrowRight />
          </IconBase>
        </button> -->
      </div>
    </div>
  </div>
</template>

<script>
import UploadImgLabel from "@/components/settings/UploadImgLabel.vue";
import { auth, fb, functions, rtdb, storage } from "@/db";
import GenreSelect from "@/components/settings/GenreSelect.vue";
import IconCancel from "@/assets/icons/IconCancel.vue";
import IconArrowRight from "@/assets/icons/IconArrowRight.vue";
import IconBase from "@/assets/icons/IconBase.vue";
import IconCheck from "@/assets/icons/IconCheck.vue";
import { v4 as uuid } from "uuid";
import _, { delay } from "lodash";
import LocationInput from "@/components/misc/LocationInput.vue";
import ToggleSwitch from "@/components/misc/ToggleSwitch.vue";
import { sanitizeNameFrom } from "@/common";

export default {
  name: "SettingsLabelProfile",
  components: {
    LocationInput,
    IconCheck,
    IconBase,
    IconArrowRight,
    IconCancel,
    GenreSelect,
    UploadImgLabel,
    ToggleSwitch,
  },
  props: {
    /**
     * @type {labelSettings}
     */
    labelSettings: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      logo: this.labelSettings.logo,
      labelName: this.labelSettings.labelName,
      genreSelected: (this.labelSettings.genres ?? "")
        .split(",")
        .map((g) => g.trim())
        .filter(Boolean),
      location: this.labelSettings.location ?? "",
      shortDescription: this.labelSettings.shortDescription ?? "",
      description: this.labelSettings.description ?? "",
      externalLinks: _.cloneDeep(this.labelSettings.externalLinks ?? []).map(
        (d) => ({
          ...d,
          id: uuid(),
        })
      ),
      saving: false,
      publicProfile: this.labelSettings.publicProfile ?? false, // <- added
      mailSubscriptionStatus: this.labelSettings.mailSubscriptionStatus ?? true,
      showDeleteOption: false,
      showChangePassword: false,
      deleteAccPassword: "",
      currentPassword: "",
      newPassword: "",
      confirmNewPassword: "",
      usernameError: "",
    };
  },
  watch: {
    "labelSettings.genres"(newVal) {
      this.genreSelected = (newVal ?? "").split(",").map((g) => g.trim()).filter(Boolean);
    },
  },
  mounted() {
    this.externalLinks.push(this.createNewLinkObj());
  },
  methods: {
    restoreLabelNameIfEmpty() {
      if (!this.labelName || !this.labelName.trim()) {
        this.labelName = this.labelSettings.labelName;
      }
    },
    setLogo(logo) {
      this.logo = logo;
    },
    createNewLinkObj() {
      return { id: uuid(), url: "", title: "" };
    },
    linkDataChanged() {
      const lastLink = this.externalLinks[this.externalLinks.length - 1];
      if (lastLink.url.trim() || lastLink.title.trim()) {
        this.externalLinks.push(this.createNewLinkObj());
      }
    },
    handleSaveAndClose() {
      this.saveData((success) => {
        if (success) {
          console.log("Saved successfully");
          this.$store.dispatch("togglePopMess", "Changes saved!");
        }
      });
    },
    handleNext() {
      if (!this.dataChanged) {
        this.$emit("nextTab");
      } else {
        this.saveData((success) => {
          if (success) {
            this.$emit("nextTab");
          }
        });
      }
    },
    async saveData(onComplete) {
      if (!this.dataChanged) {
        onComplete(true);
        return;
      }

      this.saving = true;

      this.$emit("saveSettings", this.newDataObj, (success, error) => {
        this.saving = false;
        if (!success && error) {
          this.usernameError = error;
        } else {
          this.usernameError = "";
        }
        onComplete?.(success);
      });
    },
    goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1); // Go back one step
      } else {
        this.$router.push("/"); // Navigate to the home page
      }
    },
    logout() {
      return this.$store.dispatch("logout");
    },
    async deleteAccount() {
      try {
        const user = auth.currentUser;
        if (!user) {
          alert("No user logged in");
          return;
        }

        // Check if user signed in with Google, Apple or email/password
        const providerIds = new Set(
          (user.providerData ?? []).map((p) => p.providerId)
        );
        const isGoogleUser = providerIds.has("google.com");
        const isAppleUser = providerIds.has("apple.com");

        let reauthPromise;

        if (isGoogleUser) {
          // For Google SSO users, use popup re-authentication
          const provider = new fb.auth.GoogleAuthProvider();
          reauthPromise = user.reauthenticateWithPopup(provider);
        } else if (isAppleUser) {
          const provider = new fb.auth.OAuthProvider("apple.com");
          reauthPromise = user.reauthenticateWithPopup(provider);
        } else {
          // For email/password users, prompt for password
          const password = prompt(
            "Please enter your password to confirm account deletion:"
          );
          if (!password) {
            return; // User cancelled
          }
          const credential = fb.auth.EmailAuthProvider.credential(
            user.email,
            password
          );
          reauthPromise = user.reauthenticateWithCredential(credential);
        }

        await reauthPromise;
        console.log("User re-authenticated.");

        const deleteMyAccount = functions.httpsCallable("deleteMyAccount");
        await deleteMyAccount();
        console.log("User DELETED.");
        this.$router.push("/");
        location.reload();
      } catch (err) {
        console.error(err);
        alert((err && err.message) || "Authentication failed. Please try again.");
      }
    },
    resetPasswordForm() {
      this.newPassword = "";
      this.confirmNewPassword = "";
      this.currentPassword = "";
      this.showChangePassword = false;
    },
    savePassword() {
      if (this.passwordMismatch) {
        alert("Passwords do not match");
        return;
      }
      if (this.newPassword.length > 1) {
        const user = auth.currentUser;
        const newPass = this.newPassword;
        const credential = fb.auth.EmailAuthProvider.credential(
          user.email,
          this.currentPassword
        );
        // Prompt the user to re-provide their sign-in credentials
        user
          .reauthenticateWithCredential(credential)
          .then(() => {
            console.log("User re-authenticated.");
            user.updatePassword(newPass).then(() => {
              console.log("Update password successful");
              this.resetPasswordForm();
              this.$store.dispatch(
                "togglePopMess",
                "Password changed successfully!"
              );
              this.$router.go();
            });
          })
          .catch((error) => {
            alert(error.message);
          });
      } else {
        console.log("Nothing to save here.");
      }
    },
  },
  computed: {
    passwordMismatch() {
      return (
        this.newPassword &&
        this.confirmNewPassword &&
        this.newPassword !== this.confirmNewPassword
      );
    },
    newDataObj() {
      const obj = {
        labelName: this.labelName.trim(),
        genres: this.genreSelected.join(",").trim(),
        location: this.location.trim(),
        shortDescription: this.shortDescription.trim(),
        description: this.description.trim(),
        externalLinks: this.externalLinks
          .map((l) => ({
            url: l.url.trim(),
            title: l.title.trim(),
          }))
          .filter((l) => l.url && l.title),
        logo: this.logo,

        publicProfile: this.publicProfile, // ← added
        mailSubscriptionStatus: this.mailSubscriptionStatus,
      };

      // If labelName changed, also update username (convert to lowercase for case-insensitive matching)
      if (this.labelSettings.labelName !== obj.labelName) {
        obj.username = sanitizeNameFrom(obj.labelName).toLowerCase();
      } else {
        delete obj.labelName;
      }

      if ((this.labelSettings.genres ?? "") === obj.genres) {
        delete obj.genres;
      }

      if ((this.labelSettings.location ?? "") === obj.location) {
        delete obj.location;
      }

      if (
        (this.labelSettings.shortDescription ?? "") === obj.shortDescription
      ) {
        delete obj.shortDescription;
      }

      if ((this.labelSettings.description ?? "") === obj.description) {
        delete obj.description;
      }

      if (
        _.isEqual(this.labelSettings.externalLinks ?? [], obj.externalLinks)
      ) {
        delete obj.externalLinks;
      }

      if ((this.labelSettings.logo ?? null) === (obj.logo ?? null)) {
        delete obj.logo;
      }

      if ((this.labelSettings.publicProfile ?? false) === obj.publicProfile) {
        delete obj.publicProfile; // ← added
      }

      if (
        (this.labelSettings.mailSubscriptionStatus ?? true) ===
        obj.mailSubscriptionStatus
      ) {
        delete obj.mailSubscriptionStatus;
      }

      return obj;
    },
    dataChanged() {
      return Object.keys(this.newDataObj).length > 0;
    },
  },
  watch: {
    labelSettings(newVal, oldVal) {
      // Wait for data to load and then scroll
      if (!oldVal && newVal && this.$route.hash.includes("opt-out")) {
        delay(() => {
          this.$refs.optOut.scrollIntoView();
        }, 1000);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";
@import "@/scss/_classes.scss";
@import "@/scss/_mixins.scss";

.autocomplete-list-item-label {
  color: black;
}

/* Description fields - character count + scrollable overflow */
.desc-field {
  position: relative;

  .char-count {
    position: absolute;
    right: $mg-desktop-md;
    bottom: calc(#{$mg-desktop-md} / 2);
    pointer-events: none;
  }
}

.desc-input {
  overflow-x: auto;
  overflow-y: hidden;
  padding-right: 2.5rem;
  -webkit-overflow-scrolling: touch;
}

.desc-textarea-wrap {
  .desc-textarea {
    overflow-y: auto;
    overflow-x: hidden;
    max-height: 140px;
    resize: vertical;
    min-height: 60px;
    padding-right: 2.5rem;
    padding-bottom: 1.5rem;
    -webkit-overflow-scrolling: touch;
    word-wrap: break-word;
  }
}
</style>
